import { orgHref } from '../lib/public-router'
import type { Thanks } from '../lib/two-step-payment'
import { Button, PaymentThanks } from '../ui'
import { GiveDone } from './GiveFrame'
import { KioskDoneOr } from './kiosk'

export function CampaignThanks({
  thanks,
  unlisted,
  orgShortId,
  orgName,
  kiosk,
  onAnother,
}: {
  thanks: Thanks | null
  unlisted: boolean
  orgShortId: string
  orgName: string
  kiosk: boolean
  onAnother: () => void
}) {
  return (
    <GiveDone>
      <PaymentThanks
        appearance="page"
        thanks={
          thanks ?? {
            headline: 'Thank you.',
            receipt: 'There is nothing else for you to do.',
            record: [],
          }
        }
        note={
          thanks && unlisted
            ? 'Your request not to be listed was recorded.'
            : undefined
        }
      >
        <KioskDoneOr kiosk={kiosk}>
          <a href={orgHref(orgShortId, '')}>Back to {orgName}</a>
          <Button variant="secondary" onClick={onAnother}>
            Make another donation
          </Button>
        </KioskDoneOr>
      </PaymentThanks>
    </GiveDone>
  )
}
